import { render, staticRenderFns } from "./AllTestResultsUser.vue?vue&type=template&id=9f67f5fc&"
import script from "./AllTestResultsUser.vue?vue&type=script&lang=js&"
export * from "./AllTestResultsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports